import { useEffect, useState } from "react";
import { api } from "../api";
import { useI18n } from "../I18nContext";

const PUBLIC_COLUMNS = [
  { key: "in_progress", labelKey: "whatsNext.col.in_progress", color: "var(--accent)", icon: "🚀" },
  { key: "up_next", labelKey: "whatsNext.col.up_next", color: "#c4a3ff", icon: "🎯" },
  { key: "shipped", labelKey: "whatsNext.col.shipped", color: "#6ed09f", icon: "✓" },
];

export default function WhatsNext() {
  const { t, lang } = useI18n();
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/whats-next").then((r) => setItems(r.data)).catch(() => setItems([]));
  }, []);

  if (items === null) return <div className="tb-loading">{t("common.loading")}</div>;

  return (
    <div className="tb-page" data-testid="whats-next-page">
      <h1 className="tb-h1" data-testid="whats-next-heading">{t("whatsNext.publicTitle")}</h1>
      <p className="tb-muted" style={{ marginTop: 4, marginBottom: 28, maxWidth: 640 }}>
        {t("whatsNext.publicIntro")}
      </p>

      {items.length === 0 ? (
        <div className="tb-block" style={{ textAlign: "center", padding: "3rem" }}>
          <p className="tb-muted">{t("whatsNext.publicEmpty")}</p>
        </div>
      ) : (
        <div className="tb-roadmap-public">
          {PUBLIC_COLUMNS.map((col) => {
            const colItems = items.filter((i) => i.status === col.key);
            if (colItems.length === 0) return null;
            return (
              <section key={col.key} className="tb-roadmap-section" data-testid={`public-section-${col.key}`}>
                <h2 style={{ color: col.color }}>
                  <span style={{ marginRight: 8 }}>{col.icon}</span>{t(col.labelKey)}
                </h2>
                <div className="tb-roadmap-public-list">
                  {colItems.map((it) => (
                    <div key={it.id} className="tb-roadmap-public-card" data-testid={`public-item-${it.id}`}>
                      <strong>{it.title}</strong>
                      {it.description && <p>{it.description}</p>}
                      {col.key === "shipped" && it.shipped_at && (
                        <span className="tb-muted" style={{ fontSize: "0.78rem" }}>
                          {new Date(it.shipped_at).toLocaleDateString(lang === "fr" ? "fr-CA" : "en-US", { year: "numeric", month: "short", day: "numeric" })}
                        </span>
                      )}
                    </div>
                  ))}
                </div>
              </section>
            );
          })}
        </div>
      )}

      <div className="tb-block" style={{ marginTop: 24, padding: "1.4rem", textAlign: "center", background: "rgba(110, 184, 255, 0.05)", border: "1px solid rgba(110, 184, 255, 0.18)" }}>
        <p style={{ margin: 0, fontSize: "0.9rem" }}>
          💡 {t("whatsNext.publicCta")} <a href="/app/feedback" style={{ color: "var(--accent)", fontWeight: 600 }}>{t("whatsNext.sendFeedback")} →</a>
        </p>
      </div>
    </div>
  );
}
